/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import moment from 'moment-timezone';
import {
  handleCommaSeparatedAmount,
  handleExistingCommentList,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import * as actionTypes from './ActionTypes';
import { calculateTotalSum } from '../components/gridComponents/tableHead';

moment.tz.setDefault(process.env.REACT_APP_TIMEZONE);
const axiosPayLoad = {
  searchScreenObj: {},
  updateDetails: {
    flag: true,
  },
  disabledIntPaidColObjROSI: {},
  allCommonDropDownDataList: [],
  searchPickInvAssociateScreenObj: {},
  pervSearchPickInvScreenData: {},
  pervSearchScreenData: {},
  searchPickInvoiceAssScreenErrors: [],
  errorMessagesInRedux: {
    searchScreenErrors: [],
    detailScreenErrors: {},
  },
  checksGridList: [],
  manufacturerList: [],
  quarter: '',
  activeInvoiceNum: [],
  invoiceNumCount: '',
  headerAllocatePaymentData: {},
  ROSIGridList: {},
  duplicateROSIGridList: {},
  summaryGridList: {},
  rsAddValueList: {},
  generalSystemParameter: [],
  failedAPIMsg: null,
  actionsClickedGridLevel: {},
  getDeclareCheckAllocation: {},
  istrDeAlloc: {},
  deallocateNdcRosi: {},
  addEditAllocatePaymentDetailObj: {},
  isIDBLMfgUB: true,
  activeDetailScreenTabs: [],
  hasAcknowledged: false,
  isPopupCancelled: false,
  discNDCList: [],
  duplicateROSIInterestIndex: null,
  setSameDiscValue: false,
  isHandleOkPayRem: false,
};

let tempObj = [];
let detailObj = {};
let newObj = [];
let summaryGird = [];
const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.ALLOCATE_PAYMENT_SEARCH_SCREEN:
      return { ...state, searchScreenObj: action.searchScreenObj };
    case actionTypes.UPDATE_DETAILS:
      return { ...state, updateDetails: action.updateDetails };
    case actionTypes.DISABLED_INT_PAID_COLUMN_ROSI:
      return {
        ...state,
        disabledIntPaidColObjROSI: action.disabledIntPaidColObjROSI,
      };
    case actionTypes.GET_COMMON_DROPDOWN_AP:
      return {
        ...state,
        allCommonDropDownDataList: action.allCommonDropDownDataList,
      };
    case actionTypes.ISTR_DEALLOC_DATA:
      return { ...state, istrDeAlloc: action.payload };
    case actionTypes.DEALLOCATE_NDC_ROSI:
      return { ...state, deallocateNdcRosi: action.payload };
    case actionTypes.SET_DUPLICATE_ROSI_INTEREST_INDEX:
      return { ...state, duplicateROSIInterestIndex: action.payload };
    case actionTypes.SET_NEW_OLD_ROSI:
      return { ...state, newOldColVals: action.payload };
    case actionTypes.HANDLE_ERROR_MESSAGE_FOR_ALLOCATE_PAY:
      return { ...state, errorMessagesInRedux: action.errorMessagesInRedux };
    case actionTypes.ERROR_MESSAGE_SEARCH_SCREEN:
      return {
        ...state,
        searchPickInvoiceAssScreenErrors:
          action.searchPickInvoiceAssScreenErrors,
      };
    case actionTypes.GET_CHECK_ALLOCATE_PAYMENT_DETAILS:
      if (action.checksGridList?.length > 0) {
        tempObj = action.checksGridList.map((item) => {
          item.checkPayeeCdVal = item.checkPayeeCd;
          item.batchDt = item.batchDt
            ? moment(item?.batchDt).format('MM/DD/YYYY')
            : null;
          item.checkDt = item.checkDt
            ? moment(item?.checkDt).format('MM/DD/YYYY')
            : null;
          item.postmarkedDt = item.postmarkedDt
            ? moment(item?.postmarkedDt).format('MM/DD/YYYY')
            : null;
          item.receivedDt = item.receivedDt
            ? moment(item?.receivedDt).format('MM/DD/YYYY')
            : null;
          if (!item.totAllocatedAmt?.toString()?.includes('$'))
            item.totAllocatedAmt = item.totAllocatedAmt
              ? handleCommaSeparatedAmount(item.totAllocatedAmt)
              : `$ ${parseFloat(0).toFixed(2)}`;
          if (!item.checkAmt?.toString()?.includes('$'))
            item.checkAmt = item.checkAmt
              ? handleCommaSeparatedAmount(item.checkAmt)
              : `$ ${parseFloat(0).toFixed(2)}`;
          return item;
        });
      } else {
        tempObj = [];
      }
      return { ...state, checksGridList: tempObj };
    case actionTypes.GET_MANUFACTURER_DATA_A_PAYMENT:
      return { ...state, manufacturerList: action.manufacturerList };
    case actionTypes.GET_QUARTER_DATA_A_PAYMENT:
      return { ...state, quarter: action.quarter };
    case actionTypes.ALLOCATE_PAYMENT_SEARCH_PICK_INVOICE_ASSOCIATE_SCREEN:
      return {
        ...state,
        searchPickInvAssociateScreenObj: action.searchPickInvAssociateScreenObj,
      };
    case actionTypes.EXISTING_INVOICE_NUMBER:
      return { ...state, invoiceNumCount: action.invoiceNumCount };
    case actionTypes.ROSI_PQAS_GIRD_HEADER_DATA:
      detailObj = action.headerAllocatePaymentData;
      if (action?.invoiceNum && action?.checkLogNum && !action?.isPqas) {
        if (Object.keys(action.headerAllocatePaymentData).length > 0) {
          if (
            detailObj[`${action?.invoiceNum}-${action?.checkLogNum}`]
              ?.corrLinkId
          ) {
            handleExistingCommentList([
              {
                corrLinkId:
                  detailObj[`${action?.invoiceNum}-${action?.checkLogNum}`]
                    ?.corrLinkId,
              },
            ]).then((res) => {
              if (res?.ccCommentsExist) {
                detailObj[
                  `${action?.invoiceNum}-${action?.checkLogNum}`
                ].ccCommentsExist = res.ccCommentsExist;
              }
            });
          }
        }
      }
      return { ...state, headerAllocatePaymentData: detailObj };
    case actionTypes.ROSI_GRID_DATA:
      newObj = action.ROSIGridList;
      if (action?.invoiceNum && action?.checkLogNum) {
        if (
          newObj[`${action?.invoiceNum}-${action?.checkLogNum}`] &&
          !newObj[`${action?.invoiceNum}-${action?.checkLogNum}`]?.filter(
            (x) => {
              return x.addEditRow;
            }
          ).length > 0
        ) {
          const headerObj = state.headerAllocatePaymentData[
            `${action?.invoiceNum}-${action?.checkLogNum}`
          ]
            ? state.headerAllocatePaymentData[
                `${action?.invoiceNum}-${action?.checkLogNum}`
              ]
            : detailObj;
          const reconciliationNumber = headerObj?.recancilationNumber;
          if (action?.APICall === 'getCallCommentAPI') {
            handleExistingCommentList(
              newObj[`${action?.invoiceNum}-${action?.checkLogNum}`],
              '',
              'allList'
            ).then((res) => {
              newObj[`${action?.invoiceNum}-${action?.checkLogNum}`] = res?.map(
                (item) => {
                  item.addEditRow = false;
                  item.disabledForAdjustedURA = false;
                  item.disabledForUnitsAdjusted = false;
                  item.disabledForDisputedUnits = false;
                  item.disabledForUnitsPaid = false;
                  item.disabledForCcAc1 = false;
                  item.disabledForCcAc2 = false;
                  item.disabledForCcAc3 = false;
                  item.disabledForCcDc1 = false;
                  item.disabledForCcDc2 = false;
                  item.disabledForCcDc3 = false;
                  item.disabledForInvoiceCorrectionAmt = false;
                  item.disabledForWithheldInvoiceAmt = false;
                  item.disabledForPaidAmt = false;
                  item.autoFocusCcAc1 = false;
                  item.autoFocusCcAc2 = false;
                  item.autoFocusCcAc3 = false;
                  item.autoFocusCcDc1 = false;
                  item.autoFocusCcDc2 = false;
                  item.autoFocusCcDc3 = false;
                  item.ccPaidInFullInd = item.statusCd === 'PIF' ? 1 : 0;
                  if (
                    item?.invRecSeqNum === reconciliationNumber ||
                    item?.invRecSeqNum === 0
                  ) {
                    item.disabledForPaidInFullInd = false;
                  } else {
                    item.disabledForPaidInFullInd = true;
                  }
                  item.disabledForInterestCalc = true;

                  if (
                    item.invRecSeqNum === reconciliationNumber ||
                    item.invRecSeqNum === 0
                  ) {
                    if (parseInt(item.ccPaidInFullInd, [0, 1]) === 1) {
                      item.disabledForAdjustedURA = true;
                      item.disabledForUnitsAdjusted = true;
                      item.disabledForDisputedUnits = true;
                      item.disabledForUnitsPaid = true;
                      item.disabledForCcAc1 = true;
                      item.disabledForCcAc2 = true;
                      item.disabledForCcAc3 = true;
                      item.disabledForCcDc1 = true;
                      item.disabledForCcDc2 = true;
                      item.disabledForCcDc3 = true;
                      item.disabledForInvoiceCorrectionAmt = true;
                      item.disabledForWithheldInvoiceAmt = true;
                      item.disabledForPaidAmt = true;
                    } else {
                      item.disabledForAdjustedURA = false;
                      item.disabledForUnitsAdjusted = false;
                      item.disabledForDisputedUnits = false;
                      item.disabledForUnitsPaid = false;
                      item.disabledForCcAc1 = false;
                      item.disabledForCcAc2 = false;
                      item.disabledForCcAc3 = false;
                      item.disabledForCcDc1 = false;
                      item.disabledForCcDc2 = false;
                      item.disabledForCcDc3 = false;
                      item.disabledForInvoiceCorrectionAmt = false;
                      item.disabledForWithheldInvoiceAmt = false;
                      item.disabledForPaidAmt = false;
                    }
                  } else {
                    item.disabledForAdjustedURA = true;
                    item.disabledForUnitsAdjusted = true;
                    item.disabledForDisputedUnits = true;
                    item.disabledForUnitsPaid = true;
                    item.disabledForCcAc1 = true;
                    item.disabledForCcAc2 = true;
                    item.disabledForCcAc3 = true;
                    item.disabledForCcDc1 = true;
                    item.disabledForCcDc2 = true;
                    item.disabledForCcDc3 = true;
                    item.disabledForInvoiceCorrectionAmt = true;
                    item.disabledForWithheldInvoiceAmt = true;
                    item.disabledForPaidAmt = true;
                  }
                  item.ccAc1 = item.ccAc1 ? item.ccAc1 : '-1';
                  item.ccAc2 = item.ccAc2 ? item.ccAc2 : '-1';
                  item.ccAc3 = item.ccAc3 ? item.ccAc3 : '-1';
                  item.ccDc1 = item.ccDc1 ? item.ccDc1 : '-1';
                  item.ccDc2 = item.ccDc2 ? item.ccDc2 : '-1';
                  item.ccDc3 = item.ccDc3 ? item.ccDc3 : '-1';
                  if (parseInt(headerObj?.alisComm, [0, 1]) === 0) {
                    const temp = item.ndc?.split('-');
                    if (temp?.length > 2) {
                      item.ndc = `${temp[1]}-${temp[2]}`;
                    }
                  }
                  return item;
                }
              );
            });
          }
        }
      }
      return { ...state, ROSIGridList: newObj };
    case actionTypes.SUMMARY_GRID_DATA:
      summaryGird = action.summaryGridList;
      if (action?.invoiceNum && action?.checkLogNum) {
        if (
          action.summaryGridList[`${action?.invoiceNum}-${action?.checkLogNum}`]
        ) {
          summaryGird[`${action?.invoiceNum}-${action?.checkLogNum}`] =
            summaryGird[`${action?.invoiceNum}-${action?.checkLogNum}`]?.map(
              (item, index) => {
                item.key = index;
                item.disabledForIntPaid = false;
                item.isAllowFormatterIntPaid =
                  item.isAllowFormatterIntPaid || false;
                item.bgColorForIntPaid = '';
                item.intPaid = item.intPaid;
                if (!item.currentPrincipalAmount?.toString()?.includes('$'))
                  item.currentPrincipalAmount = `$ ${calculateTotalSum(
                    'amountOwedNdc',
                    state?.ROSIGridList[
                      `${action?.invoiceNum}-${action?.checkLogNum}`
                    ]
                  )}`;
                if (!item.totalIntPaid?.toString()?.includes('$'))
                  item.totalIntPaid = `$ ${
                    item.totalIntPaid
                      ? parseFloat(item.totalIntPaid).toFixed(2)
                      : parseFloat(0).toFixed(2)
                  }`;
                if (!item.totalIntSettled?.toString()?.includes('$'))
                  item.totalIntSettled = `$ ${
                    item.totalIntSettled
                      ? parseFloat(item.totalIntSettled).toFixed(2)
                      : parseFloat(0).toFixed(2)
                  }`;
                if (!item.totalInterestCalc?.toString()?.includes('$'))
                  item.totalInterestCalc = `$ ${
                    item.totalInterestCalc
                      ? parseFloat(item.totalInterestCalc).toFixed(2)
                      : parseFloat(0).toFixed(2)
                  }`;
                if (!item.totalPrincipalPaid?.toString()?.includes('$'))
                  item.totalPrincipalPaid = `$ ${
                    item.totalPrincipalPaid
                      ? parseFloat(item.totalPrincipalPaid).toFixed(2)
                      : parseFloat(0).toFixed(2)
                  }`;
                if (!item.principalPaid?.toString()?.includes('$'))
                  item.principalPaid = `$ ${
                    item.principalPaid
                      ? parseFloat(item.principalPaid).toFixed(2)
                      : parseFloat(0).toFixed(2)
                  }`;
                return item;
              }
            );
        }
      }
      return { ...state, summaryGridList: summaryGird };
    case actionTypes.PERV_SEARCH_SCREEN_DATA:
      return { ...state, pervSearchScreenData: action.pervSearchScreenData };
    case actionTypes.GRID_RS_ADD_VALUES:
      return { ...state, rsAddValueList: action.rsAddValueList };
    case actionTypes.PERV_SEARCH_PICK_INV_ASSOCIATE_SCREEN_DATA:
      return {
        ...state,
        pervSearchPickInvScreenData: action.pervSearchPickInvScreenData,
      };
    case actionTypes.GRID_LEVEL_ACTIONS_AP:
      return {
        ...state,
        actionsClickedGridLevel: action.actionsClickedGridLevel,
      };
    case actionTypes.PARTIALLY_PAID_DRUGS:
      return { ...state, partiallyPaidDrugs: action.partiallyPaidDrugs };
    case actionTypes.ACTIVE_INVOICE_NUM:
      return { ...state, activeInvoiceNum: action.activeInvoiceNum };
    case actionTypes.FAILED_API_ERR_MSG:
      return { ...state, failedAPIMsg: action.failedAPIMsg };
    case actionTypes.GET_GENERAL_SYSTEM_PARAMETER_AP:
      return {
        ...state,
        generalSystemParameter: action.generalSystemParameter,
      };
    case actionTypes.GET_DUPLICATE_ROSI_GIRD:
      return { ...state, duplicateROSIGridList: action.duplicateROSIGridList };
    case actionTypes.GET_DECLARE_CHECKALLOCATION:
      return {
        ...state,
        getDeclareCheckAllocation: action.getDeclareCheckAllocation,
      };
    case actionTypes.ALLOCATE_PAYMENT_DETAIL_TAB_DATA:
      return {
        ...state,
        addEditAllocatePaymentDetailObj: action.addEditAllocatePaymentDetailObj,
      };
    case actionTypes.ROSI_PQAS_GIRD_HEADER_DATA_NOTIFY:
      return {
        ...state,
        headerAllocatePaymentAmtNotify: action.headerAllocatePaymentAmtNotify,
      };
    case actionTypes.ROSI_PQAS_IS_IDBL_MFG_UB:
      return {
        ...state,
        isIDBLMfgUB: action.isIDBLMfgUB,
      };
    case actionTypes.ACTIVE_ROSI_PQAS_TAB_DETAILS:
      return {
        ...state,
        activeDetailScreenTabs: action.activeDetailScreenTabs,
      };
    case actionTypes.SET_POPUP_ACKNOWLEDGED:
      return {
        ...state,
        hasAcknowledged: action.hasAcknowledged,
      };
    case actionTypes.RESET_POPUP_ACKNOWLEDGED:
      return {
        ...state,
        hasAcknowledged: false,
      };
    case actionTypes.SET_POPUP_CANCEL_FLAG:
      return {
        ...state,
        isPopupCancelled: true,
      };
    case actionTypes.RESET_POPUP_CANCEL_FLAG:
      return {
        ...state,
        isPopupCancelled: false,
      };
    case actionTypes.ROSI_DISC_NDCS:
      return {
        ...state,
        discNDCList: action.discNDCList,
      };
    case actionTypes.CURR_ROSI_COL_ID:
      return { ...state, currRosiColId: action.payload };
    case actionTypes.SAME_DISC_VAL:
      return { ...state, setSameDiscValue: action.payload };
    case actionTypes.IS_HANDLE_OK_PAY_REM:
      return { ...state, isHandleOkPayRem: action.payload };
    case actionTypes.REMOVE_ACTIVE_DETAIL_SCREEN_TAB:
      const filteredTabs =
        state.activeDetailScreenTabs?.filter(
          (item) =>
            !(
              item.invoiceNumber?.toString() ===
                action.payload.invoiceNumber?.toString() &&
              item.checkNumber?.toString() ===
                action.payload.checkNumber?.toString()
            )
        ) || [];
      return {
        ...state,
        activeDetailScreenTabs: filteredTabs,
      };
    default:
      return state;
  }
};

export default reducer;
